import React from 'react';
import { FileText } from 'lucide-react';

interface JobNotesProps {
    lossDescription: string;
    setLossDescription: (val: string) => void;
    notes: string;
    setNotes: (val: string) => void;
    embedded?: boolean;
    fillHeight?: boolean;
}

export const JobNotes: React.FC<JobNotesProps> = ({
    lossDescription,
    setLossDescription,
    notes,
    setNotes,
    embedded = false,
    fillHeight = false
}) => {
    const containerClass = fillHeight ? 'space-y-2 h-full flex flex-col min-h-0' : 'space-y-2';
    const notesFieldClass = fillHeight
        ? 'input-field min-h-24 flex-1 resize-y'
        : 'input-field min-h-24 resize-y';

    const content = (
        <>
            <div className="flex items-center gap-2 text-accent-secondary mb-2">
                <FileText size={18} />
                <h3 className="text-sm font-black uppercase tracking-widest">Loss Notes</h3>
            </div>
            <label className="text-micro font-bold text-text-muted uppercase">General Description of Loss</label>
            <textarea
                value={lossDescription}
                onChange={(e) => setLossDescription(e.target.value)}
                className="input-field min-h-24 resize-y"
                placeholder="Enter the FNOL description here..."
            />
            <label className="text-micro font-bold text-text-muted uppercase">FNOL Notes</label>
            <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                className={notesFieldClass}
                placeholder="Add any additional internal notes here..."
            />
        </>
    );

    if (embedded) {
        return <div className={containerClass}>{content}</div>;
    }

    return (
        <div className="space-y-2 bg-surface-hover p-4 rounded-xl border border-divider-subtle">
            {content}
        </div>
    );
};
